import { cashnator, decashnator, isNumeric } from "../utils/functions";

/** Formata centavos para máscara de input R$ (pt-BR). */
export const formatMoneyInput = (cents) => cashnator(cents) || "R$0,00";

/** Converte texto mascarado (ou digits) em centavos; null se inválido. */
export const parseMoneyInput = (value) => {
  const cents = decashnator(value);
  if (!isNumeric(cents)) {
    return null;
  }
  return Number(cents);
};

export const handleMoneyInputChange = (rawValue, onCentsChange) => {
  const cents = parseMoneyInput(rawValue);
  if (cents == null) {
    return;
  }
  onCentsChange(cents);
};
